import * as styles from './Contents.css';
import { SocialShareAndroidLineIcon } from '@/assets/icons';
import Button from '@/components/Button/Button';
import useToast from '@/hooks/useToastPopup.tsx';
import useApplyEventId from '../../hooks/useApplyEventId';
import { useEventInfo } from '@/features/apply-event/hooks/useEvent';

const APP_LINK = 'https://ixio.onelink.me/qgZo/xoqhzvdd';

const Contents = () => {
  const eventId = useApplyEventId();
  const eventInfo = useEventInfo(eventId);
  const showToast = useToast();

  const handleClick = () => {
    navigator.clipboard.writeText(APP_LINK);
    showToast({ message: '이벤트 URL이 복사되었어요' });
  };

  return (
    <>
      <div className={styles.head}>
        <Button
          type="outline"
          category="neutral"
          size="small"
          onClick={handleClick}
        >
          <div className={styles.copy}>
            <SocialShareAndroidLineIcon width={16} height={16} /> 이벤트 링크
            복사하기
          </div>
        </Button>
      </div>
      <div className={styles.body}>
        <img
          src={eventInfo?.imageUrl}
          alt="이벤트 상세 이미지"
          className={styles.image}
        />
      </div>
    </>
  );
};

export default Contents;
